import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_PROFESSION_REQUEST,
  ADD_PROFESSION_SUCCESS,
  ADD_PROFESSION_FAILURE,
  UPDATE_PROFESSION_REQUEST,
  UPDATE_PROFESSION_SUCCESS,
  UPDATE_PROFESSION_FAILURE,
  DELETE_PROFESSION_REQUEST,
  DELETE_PROFESSION_SUCCESS,
  DELETE_PROFESSION_FAILURE,
  GET_PROFESSION_REQUEST,
  GET_PROFESSION_SUCCESS,
  GET_PROFESSION_FAILURE,
} from "../constants/professionConstant";

export const addProfessionAction = (professionData) => async (dispatch) => {
  try {
     
    dispatch({ type: ADD_PROFESSION_REQUEST });
    console.log('professionData',professionData);

    const url = ApiUrl.addProfession;
    console.log('url',ApiUrl.addProfession);
    const { data } = await axios.post(url, professionData);

    if (data.success) {
      dispatch({
        type: ADD_PROFESSION_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: ADD_PROFESSION_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);

    dispatch({
      type: ADD_PROFESSION_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });

    return false;
  }
};



export const updateProfessionAction =
  (professionId, professionDetails) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_PROFESSION_REQUEST });
      const URL = `${ApiUrl.updateProfession}?professionId=${professionId}`;
      const { data } = await axios.put(URL, professionDetails);
      if (data.success) {
        dispatch({
          type: UPDATE_PROFESSION_SUCCESS,
          payload: data,
        });
        return true;
      }
    } catch (error) {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      if (error.response.status === 500) {
        dispatch({
          type: UPDATE_PROFESSION_FAILURE,
          payload: "Internal Server Error",
        });
      } else {
        dispatch({
          type: UPDATE_PROFESSION_FAILURE,
          payload: error.response.data,
        });
      }
    }
  };

export const deleteProfessionAction = (professionId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PROFESSION_REQUEST });
    const URL = `${ApiUrl.deleteProfession}?professionId=${professionId}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_PROFESSION_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_PROFESSION_FAILURE,
      payload: error.response.data,
    });
  }
};

export const getProfessionActionFn = (professionId) => async (dispatch) => {
  try {
    dispatch({ type: GET_PROFESSION_REQUEST });
    const URL = `${ApiUrl.getProfessionById}?professionId=${professionId}`;
    const { data } = await axios.get(URL);
    if (data.success) {
      dispatch({
        type: GET_PROFESSION_SUCCESS,
        payload: data.response,
      });
      return data;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: GET_PROFESSION_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: GET_PROFESSION_FAILURE,
        payload: error.response.data,
      });
    }
  }
};


